import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function BrandStory() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-41">
          {/* Visual Side - Overlapping Images */}
          <div className="w-full lg:w-1/2 relative" data-id="element-42">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 1
          }} viewport={{
            once: true
          }} className="relative z-10 w-4/5 aspect-[3/4]" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/dnFBiLf42a99KfYUr626ET/pasted-image.jpg" alt="African Craftsmanship" className="w-full h-full object-cover shadow-2xl" data-id="element-44" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.3
          }} viewport={{
            once: true
          }} className="absolute -bottom-12 -right-4 w-3/5 aspect-square z-20 border-8 border-white shadow-xl" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/ok2GGtft3ausR8pfW3rEvG/pasted-image.png" alt="Heritage Textile" className="w-full h-full object-cover" data-id="element-46" />
            </motion.div>

            {/* Decorative Gold Element */}
            <div className="absolute -top-8 -left-8 w-32 h-32 border-t-2 border-l-2 border-gold opacity-30" data-id="element-47" />
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2 space-y-8" data-id="element-48">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} data-id="element-49">
              <span className="text-gold uppercase tracking-[0.3em] text-[10px] font-bold block mb-4" data-id="element-50">
                Our Heritage
              </span>
              <h2 className="text-3xl md:text-5xl font-serif leading-tight mb-6" data-id="element-51">
                Adorned in Culture, <br data-id="element-52" />
                <span className="italic" data-id="element-53">Defined by Style</span>
              </h2>

              <div className="space-y-6 text-gray-600 text-base md:text-lg leading-relaxed" data-id="element-54">
                <p data-id="element-55">
                  TriLyn was born from a singular passion: to preserve the
                  vibrant tapestry of African culture through the lens of modern
                  fashion. We believe that what we wear is a powerful narrative
                  of who we are and where we come from.
                </p>
                <p data-id="element-56">
                  Every thread, bead, and pattern in our collection is a tribute
                  to centuries of craftsmanship. By partnering directly with
                  artisans across the continent, we bring you authentic designs
                  that honor tradition while embracing the future of global
                  style.
                </p>
              </div>

              <div className="pt-8" data-id="element-57">
                <Link to="/our-story" className="group relative inline-flex items-center gap-4 text-black font-bold uppercase tracking-widest text-sm" data-id="element-58">
                  <span className="relative z-10" data-id="element-59">Read Our Story</span>
                  <div className="w-12 h-[1px] bg-black transition-all duration-300 group-hover:w-20" data-id="element-60" />
                  <div className="absolute -bottom-2 left-0 w-0 h-[2px] bg-gold transition-all duration-300 group-hover:w-full" data-id="element-61" />
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}